import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Tab, Tabs } from './tab.interfaces';
import { OfflineService } from '../../../../services/offline.service';

@Component({
  selector: 'agenx-tab',
  standalone: true,
  imports: [NgClass],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss'
})
export class AgenxTabComponent {

  /**
   * Tabs to display
   *
   * @type {Tabs}
   * @memberof AgenxTabComponent
   */
  @Input() tabsObject: Tabs | null = null;

  /**
   * Event emitter to emit the selected tab
   *
   * @memberof AgenxTabComponent
   */
  @Output() selectedTab = new EventEmitter<Tab>()
  tabs: Tab[] = [];
  iconExcl = '';

  constructor(private offlineSrv: OfflineService) {}

  ngOnChanges(change: SimpleChanges): void {
    if (change['tabs']) {
      this.tabs = change['tabs'].currentValue
    }
  }

  ngOnInit(): void {
    Object.values(this.tabsObject!).forEach((tab: any) => {
      this.tabs.push(tab);
    });
    this.iconExcl = this.offlineSrv.loadAssetInLocal('icon-exclamacion.svg');
    this.selectTab(this.tabs[0])
  }

  selectTab(tabClicked: Tab) {
    let auxTab = this.tabs[1];
    if (tabClicked.name) {
      this.tabs.map(tab => {
        tab.active = tab.name === tabClicked.name;
      });
      this.tabs = this.tabs.filter(
        (tab, index) =>
          tab.name !== tabClicked.name && tab.name !== '' && index !== 1
      );

      // this.tabs.unshift({ name: '', active: false });
      this.tabs.push(tabClicked);
      if (!this.tabs.find((tab) => tab.name === auxTab.name)) {
        this.tabs.push(auxTab);
      }
      this.selectedTab.emit(tabClicked);
    }
  }

}
